<template>

  <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">Add Accounts</div>
                <button type="submit" class="back_button btn btn-primary pull-right" v-on:click.prevent="buttonBack()">Back</button>
            </div>
             <!--page content-->
            <div class="admin-page-content">
                <div class="app-filter-good-table-container">
                  <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-5">
                    <b-list-group>
                    <b-list-group-item href="#" v-on:click="socialAccount('facebook')">
                     <b-img src="/static/images/fb.png" rounded="circle" alt="Card with Image" style="height: 50px;width: 50px; margin-right: 10px;"></b-img>
                         Facebook
                   </b-list-group-item>
                   <b-list-group-item href="#" v-on:click="socialAccount('linkedin')">
                     <b-img src="/static/images/linkedin.png" rounded="circle" alt="Card with Image" style="height: 50px;width: 50px; margin-right: 10px;"></b-img>
                         LinkedIn
                  </b-list-group-item>
                  <b-list-group-item href="#" v-on:click="socialAccount('twitter')">
                    <b-img src="/static/images/twitter.png" rounded="circle" alt="Card with Image" style="height: 50px;width: 50px; margin-right: 10px;"></b-img>
                      Twitter
                   </b-list-group-item>

                   <b-list-group-item href="#" v-on:click="socialAccount('instagram')">
                    <b-img src="/static/images/insta.jpeg" rounded="circle" alt="Card with Image" style="height: 50px;width: 50px; margin-right: 10px;"></b-img>
                        Instagram
                    </b-list-group-item>
                </b-list-group>

              </div>
              <div class="clearfix"></div>
              <div class="col-md-12">
                        <div class="alert alert-danger" id="alertError">
                            <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                            <strong id="errorMsg" class="error"></strong>
                        </div>
                    </div>
            </div>
         </div>

        </div>
        <app-backend-footer></app-backend-footer>
  </div>




</template>
<script>
import Vue from 'vue';
import BackendFooter from '@/components/backend/partials/Footer';
import SessioMixin from '../../../mixins/sessionmixin';
import { HTTP } from '../../../http-common';
var self;

export default {
  name: 'AddAccounts',
  components: {
    'app-backend-footer': BackendFooter,
  },
  mixins: [SessioMixin],
  data() {
    return {
      fbToken : '',
      userId : 0,
    }
  },
  beforeMount: function () {
      self = this;
      self.checkLogin();
  },
  mounted: function () {
      self = this;
      var userObj = localStorage.getItem("user_obj");
      var userJson = JSON.parse(userObj);
      self.userId = userJson.id;
      console.log(self.userId);
      // $("#alertError").show();
      $("#alertError").hide();
      if(this.$route.query.error) {


        $("#alertError").show();
        $("#errorMsg").html(this.$route.query.error);

      //  if(this.$route.query.type == 'facebook') {

      //       self.fbToken = this.$route.query.status;
      //       console.log(self.fbToken);
      //       // self.facebookGetUserDetail();

      //     }


        this.$router.replace({
                        name: "",
                        query: ""
                    })

      }
  },
  methods: {
      socialAccount : function(account) {

          switch (account) {
            case 'facebook':
              self.facebookconnect();
              break;
            case 'linkedin':
              self.linkedinconnect();
              break;
            case 'twitter':
              self.twitterconnect();
              break;
            case 'instagram':
              self.instaconnect();
              break;

            default:
              break;
          }
      },
      buttonBack: function() {
          self.$router.push('/backend/social/listaccount');
      },
      facebookconnect: function() {
        console.log("ROOT TEST == ", process.env.ROOT_API + '/socialmedia/connect/facebook?auth_id=' + self.userId);
        window.location = process.env.ROOT_API + '/socialmedia/connect/facebook?auth_id=' + self.userId;
      },
      linkedinconnect: function() {
        window.location = process.env.ROOT_API + '/socialmedia/connect/linkedin?auth_id=' + self.userId;
      },
      twitterconnect: function() {
        window.location = process.env.ROOT_API + '/socialmedia/connect/twitter?auth_id=' + self.userId;
      },
      instaconnect: function() {
        window.location = process.env.ROOT_API + '/socialmedia/connect/instagram?auth_id=' + self.userId;
      },

  },

}
</script>



// WEBPACK FOOTER //
// src/components/backend/socialmedia/addAccount.vue